import { useAuthStore } from '../stores/auth';

export function useAuth() {
  const account = useAuthStore((s) => s.account);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isLoading = useAuthStore((s) => s.isLoading);

  const isSuperAdmin = account?.admin_profile?.admin_role === 'super_admin';
  const isAdmin = account?.admin_profile != null && account?.admin_profile?.enabled === true;

  return {
    account,
    isAuthenticated,
    isLoading,
    isSuperAdmin,
    isAdmin,
    adminRole: account?.admin_profile?.admin_role ?? null,
  };
}
